.wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    width: 100%;
    font-family: var(--tempest-font-sans);
}

.bar {
    width: 100%;
    height: 8px;
    background-color: var(--tempest-surface-2);
    border-radius: var(--tempest-radius-full);
    overflow: hidden;
    box-shadow: var(--tempest-shadow-inner);
}

.fill {
    height: 100%;
    background-color: var(--tempest-primary);
    border-radius: inherit;
    transition: width var(--tempest-duration-base) var(--tempest-ease-out);
}

.fill.success {
    background-color: var(--tempest-success-solid);
}
.fill.warning {
    background-color: var(--tempest-warning-solid);
}
.fill.danger {
    background-color: var(--tempest-danger-solid);
}

.indeterminate .fill {
    width: 30% !important;
    animation: tempest-progress-loop 1.4s var(--tempest-ease-in-out) infinite;
}

.label {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text-muted);
    line-height: var(--tempest-leading-snug);
    display: flex;
    justify-content: space-between;
}

@keyframes tempest-progress-loop {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(360%);
    }
}

@media (prefers-reduced-motion: reduce) {
    .indeterminate .fill {
        animation: none;
        width: 100% !important;
        opacity: 0.5;
    }
}
